<template>
<div class="mx-5 md:max-0 md:mt-10" style="background-color: #F9F9F9; height: 100vh;">
    <h1  class="flex justify-center text-2xl 100vh  mb-5 pt-10 ">Create Shift</h1>
    <form class="max-w-md mx-auto" @submit.prevent="submit" novalidate>
        <div class="relative z-0 w-full mb-5 group">
            <input type="type" name="name" v-model="form.shift" id="name"
                class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" " />
            <label for="time"
                class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Shift</label>
        </div>
        <div class="relative z-0 w-full mb-5 group">
            <input type="time" id="myTime" v-model="form.start_time" step="2" name="myTime"
                class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" " />
            <label for="myTime"
                class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Start
                time</label>
        </div>
        <div class="relative z-0 w-full mb-5 group">
            <input type="time" v-model="form.end_time" id="endtime" step="2" name="endtime"
                class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" " />
            <label for="endtime"
                class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">End
                Time</label>
        </div>
        <label class="relative flex items-center mb-5 cursor-pointer">
            <input type="checkbox" v-model="form.is_active" value="" class="sr-only peer">
            <div
                class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
            </div>
            <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Active</span>
        </label>
        <router-link to="shift"
            class="text-white mb-5 bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            Back</router-link>
        <button type="submit" :disabled="isRegisterButtonDisabled" :class="{ 'bg-gray-500 ': isRegisterButtonDisabled }"
            class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            Create Shift</button>
    </form>
</div>
</template>



<script setup>
import { ref, computed,onMounted,onUnmounted } from 'vue';
import { useShiftsStore } from '@/store/reports';
import Swal from 'sweetalert2';
import { useRouter } from 'vue-router'; // Import the useRouter function from vue-router
import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const shiftsStore = useShiftsStore();

const form = ref({
    shift: '',
    end_time: '',
    start_time: '',
    is_active: true,
});

const isRegisterButtonDisabled = computed(() => {
    const requiredFields = ['shift', 'start_time', 'end_time'];
    return requiredFields.some(field => !form.value[field]);
});
const router = useRouter();

/* eslint-disable */
const submit = async () => {
    // Perform field-level validation

    // Check overall form validation
    if (!isRegisterButtonDisabled.value) {
        await shiftsStore.postshift(form.value);
        form.value = '';
        Swal.fire({
            toast: true,
            title: 'Successfully added shift',
            icon: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
        router.push({ name: 'shift' });
    }
};

onMounted(async()=>{
  await authStore.handlepermission()
})

onUnmounted(async()=>{
  await authStore.handlepermission()
})

</script>

<style scoped>
.error-message {
    color: red;
    font-size: 0.8rem;
}

.disabled-button {
    opacity: 0.2;
    filter: grayscale(1);
}
</style>